import { FC, useEffect, useState } from "react";

import { TextField } from "@mui/material";

import { ArrayValue } from "./ArrayPropertyComponent";

interface ArrayValueComponentProps {
    value: ArrayValue;
    arrayChanged: () => void;
}

const ArrayValueComponent: FC<ArrayValueComponentProps> = ({ value, arrayChanged }) => {
    const [configValue, setConfigValue] = useState<string>("");

    useEffect(() => {
        setConfigValue(value.value);
    }, [value]);

    function SetConfigValue(event: any) {
        var configVal = event.target.value;
        setConfigValue(configVal);
        value.value = configVal;
        arrayChanged();
    }

    return (
        <TextField
            value={configValue}
            onChange={SetConfigValue}
            sx={{ width: "245px", marginBottom: "5px", marginLeft: "10px" }}
            size="small" />
    )
}

export default ArrayValueComponent;